import React from 'react';
import { Box, Text, Icon } from '@chakra-ui/react';
import { FaRegThumbsUp } from 'react-icons/fa';

const Welcome = () => {
  return (
    <Box p={8} mt={250}>
      <Text fontSize="2xl" fontWeight="bold" textAlign="center">
        Welcome to the Administration of CUROLYN
      </Text>
      <Icon as={FaRegThumbsUp} w={8} h={8} mt={4} color="teal.500" />
    </Box>
  );
};

export default Welcome;